import React from "react";
import { Grid } from "@mui/material";
import styled from "@emotion/styled";
import { black } from "../color";
import { CustomButton } from "./Layout.elements";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { queries } from "../Data/Query";

const { blackPearl } = black;


const TableGridSection = ({ setQueryIndex, border, btnTextColor, setBlackScreen, setQueryParams }) => {
  const params = new URLSearchParams(window.location.search);

  const ScrollableGrid = styled(Grid)`
    margin: 3rem 0;
    overflow-x: auto;
    @media only screen and (max-width: 1024px) {
      white-space: nowrap;
      margin: 2.5rem 0;
    }
    `;
  
  const CustomGridWithBorder = styled(Grid)({
    border: border || `2px solid ${blackPearl}`,
    minWidth: '18rem',
    padding: '1rem',
    flexDirection: 'column',
    minHeight: '15rem',
    "& h3" : {
      fontSize: '1rem',
      fontWeight: '600',
      margin: '0',
    },
    "& p" : {
      fontSize: '0.875rem'
    }
  })

  const handleCardClick = (queryId) => {
    setQueryIndex(queryId);
    setBlackScreen(false);
    params.set("q", queryId);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setQueryParams(params.toString());
  }

  return (
    <ScrollableGrid
      container
      columnGap={1}
      rowGap={1}
      wrap="nowrap"
    >
      {queries.map((query) => (
        <CustomGridWithBorder
        component="div"
        container
        wrap
        item
        md={3}
        key={query?.id}
        onClick={() => handleCardClick(query?.id)}
        style={{ cursor: 'pointer' }}
        >
          <h3>INPUT</h3>
          <p style={{ textWrap: 'wrap', minHeight: '8rem' }}>{query?.question}</p>
          <div>
            <CustomButton
              textColor={btnTextColor}
              variant="text"
              size="medium"
              endIcon={<ArrowForwardIcon />}
            >
              See Output
            </CustomButton>
          </div>
        </CustomGridWithBorder>
      ))}
    </ScrollableGrid>
  );
};

export default TableGridSection;
